module.exports = __webpack_public_path__ + "img/UL410.24838bba.png";